import {
  Sparkles,
  Target,
  Layers,
  Droplets,
  Eye,
  ClipboardCheck,
  Stethoscope,
  Building2,
  TestTube2,
  Heart,
  Building,
  type LucideIcon,
} from "lucide-react"
const SERVICE_TYPE_ICON: Record<string, LucideIcon> = {
  "Glass & Entry": Sparkles,
  "Surface Precision": Target,
  "Floor Care": Layers,
  "Restroom Reset": Droplets,
  "Smart Oversight": Eye,
  "Standard Maintenance": ClipboardCheck,
  "Clinical Suite Detail": Stethoscope,
  "Front Office Sanitization": Building2,
  "Operatory Sterilization": TestTube2,
  "Surgical Suite Care": Heart,
  "General Facility Sanitization": Building,
}

export function getServiceTypeIcon(serviceType: string): LucideIcon | null {
  return SERVICE_TYPE_ICON[serviceType] ?? null
}

export function ServiceTypePill({
  serviceType,
  className = "",
}: {
  serviceType: string
  className?: string
}) {
  const Icon = getServiceTypeIcon(serviceType)
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-lg text-xs font-medium bg-stone-100 dark:bg-stone-800 text-stone-700 dark:text-stone-300 border border-stone-200/60 dark:border-stone-700 max-w-[180px] ${className}`}
      title={serviceType}
    >
      {Icon ? <Icon className="w-3.5 h-3.5 shrink-0 text-stone-500 dark:text-stone-400" /> : null}
      <span className="truncate">{serviceType}</span>
    </span>
  )
}
